import { errorCodes } from '../../constants/errorCodes';
import { GoogleCalendarError } from './GoogleCalendarError';

const ERROR = errorCodes.googleCalendarInvalidFeatureSetup!;

export class GoogleCalendarInvalidFeatureSetup extends GoogleCalendarError {
  static get errorName() {
    return ERROR.code;
  }

  constructor(message?: string) {
    super(ERROR, message);
  }
}
